import * as React from 'react';
import { FieldProps } from '../metadataFormField';
import { ReferenceField } from '../ReferenceField/referenceField';
import { useSelector } from '../../../utils/useSelector';
import { Metadata } from '../../../types/Metadata';
import { getEmployeeName } from '../../../utils';
import './delegateField.scss';

interface AssociatedDelegate {
  employee: Metadata;
}

export const DelegateField = (props: FieldProps) => {
  const { data } = props;
  const getAPI = useSelector(s => s.app?.elFn?.getAPI);
  const [associatedDelegates, setAssociatedDelegates] = React.useState<
    AssociatedDelegate[]
  >([]);

  const priorityJourneyStep = React.useMemo(() => {
    const pjs = data?.props?.priorityJourneyStep?.[0];
    return pjs;
  }, [data?.props?.priorityJourneyStep]);

  const fetchAssociatedDelegates = React.useCallback(async () => {
    if (!getAPI) {
      return;
    }
    try {
      const { getAssociatedDelegates } = getAPI();
      const priorityJourneyStepRefId = priorityJourneyStep?.props?.refId;
      if (!priorityJourneyStepRefId) {
        setAssociatedDelegates([]);
        return;
      }
      const results = await getAssociatedDelegates(priorityJourneyStepRefId);
      const delegates: AssociatedDelegate[] = results.map(employee => ({
        employee
      }));

      setAssociatedDelegates(delegates);
    } catch (error) {
      console.error('Error fetching associated delegates:', error);
    }
  }, [getAPI, priorityJourneyStep]);

  React.useEffect(() => {
    fetchAssociatedDelegates();
  }, [fetchAssociatedDelegates]);

  return (
    <ReferenceField {...props}>
      <>
        {associatedDelegates?.length > 0 ? (
          <div className="delegate-field-associated">
            <span>
              {`Approvers already associated with this question based on selected
              metadata: `}
              {associatedDelegates
                .map(delegate =>
                  getEmployeeName(delegate.employee, { withEmpCd: true })
                )
                .join(', ')}
            </span>
          </div>
        ) : null}
      </>
    </ReferenceField>
  );
};
